import { computed } from 'vue'
import { useExtensionsStore } from '@voicenter-team/events-sdk-vue-3'
import { Extension } from '@/types/extension'

const extensionsStore = useExtensionsStore()

export const allRealtimeExtensions = computed<Extension[]>(
    () => (extensionsStore.extensionsWithCallStatus.value as unknown as Extension[] | undefined) ?? []
)
